export const USERLIST = "admin/user/list";
export const USERDETAIL = "admin/user/detail";
export const USER_EVENT = "admin/event";
export const USER_SUB_EVENTS = "admin/event/subEvents";

export const USER_TASKS = "admin/event/tasks";
export const USER_DASHBOARD = "admin/user/dashboard"


export const POSTS = "admin/user/post";

export const JOB_CATEGORY_LIST = "admin/job/category";

export const SERVICE_CATEGORY_LIST = "admin/service/category";

export const JOB_POSTING_LIST = "admin/job";

export const FLAG_POSTING_LIST = "admin/report";

export const ACTIVE_FLAG_POSTING_LIST = "admin/report/post/active";

export const SERVICE_POSTING_LIST = "admin/service";

export const JOB_DETAILS = "admin/job/detail";

export const SERVICE_DETAILS = "admin/service/detail";

export const BLOCK_USER = "admin/user/blockUnblock";

export const PRICE = "admin/job-settings";

export const DASHBOARD = "admin/dashboard";